module.exports = __webpack_public_path__ + "img/Autocolant TMHE_150mm x 180mm-01.d489ad08.jpg";